<div [class.!border-kek-purple]="selected()"
  class="rounded-[16px] border border-textbox-border px-[34px] w-full bg-surface-background pb-6 transition-colors">
  <ng-content />

  <div class="space-y-4">
    <!-- Question Section -->
    <div class="flex flex-row gap-8 justify-between items-center">
      <div
        [matTooltip]="'This is question ' + (question.index + 1)"
        class="inter-500 text-[16px] w-[40px] h-[40px] grid place-items-center border border-textbox-border rounded-full select-none flex-shrink-0 text-support-text"
        >
        {{ question.index + 1 }}
      </div>
      <ngx-editor
        [(ngModel)]="question.htmlText"
        [editor]="editor" [placeholder]="'Type here...'"
        class="font-light flex-1 rounded-[10px] border border-textbox-border" />
      <select
        [ngModel]="question.type" (ngModelChange)="onQuestionTypeChange($event)"
        class="bg-textbox-fill border border-textbox-border rounded-full px-4 py-2 inter-300 text-[14px] text-support-text appearance-none focus:outline-none flex-shrink-0">
        @for (questionType of Object.keys(QuestionType); track $index) {
          <option [value]="questionType">
            {{ questionType | camelCaseSplit }}
          </option>
        }
      </select>
    </div>

    @if (selected()) {
      <div @scaleHeightAndFade class="flex gap-8 items-center">
        <input
          [(ngModel)]="question.descriptionText"
          class="flex-1 bg-transparent outline-none inter-300 text-[14px] text-support-text border-b border-textbox-border py-1"
          placeholder="Add description or sub-title (optional)" />
        <label
          class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-4 py-2 rounded-full inter-500 text-[13px] transition-colors flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <span class="material-icons text-[16px]">upload_file</span>
          Upload Attachment
          <input (change)="handleFileInput($event)" class="hidden" type="file">
        </label>
      </div>
    }

    <!-- Answer Options Section -->
    @if (question.type === QuestionType.SingleChoice || question.type === QuestionType.MultipleChoice || question.type === QuestionType.Ranking || question.type === QuestionType.RangeSelection) {
      @if (selected()) {
        <div class="h-[1px] bg-inverted-neutral opacity-20 w-full"></div>
      }

      <div class="grid grid-cols-1 gap-1 mx-[90px]">
        @for (answerOption of question.answerOptions | orderBy: 'index':'asc'; track answerOption; let i = $index) {
          <div
            class="rounded-[12px] bg-surface-background flex items-center justify-around gap-2"
            [ngClass]="selected() ? ['border', 'border-textbox-border', 'p-[13px]'] : []"
            @scaleHeightAndFade
            >
            <div class="inter-500 text-[14px] w-[28px] h-[28px] rounded-[6px] text-center text-support-text flex items-center justify-center">
              {{ i + 1 }}
            </div>
            @if (selected()) {
              <div class="bg-inverted-neutral opacity-20 w-[1px] h-full" @fadeInOut></div>
            }
            <input
              [(ngModel)]="answerOption.text"
              [placeholder]="question.type === QuestionType.RangeSelection ? 'Label (optional)' : 'Option text...'"
              class="flex-1 bg-transparent outline-none inter-300 text-[14px]" />
            <!-- Slider value input -->
            @if (question.type === QuestionType.RangeSelection) {
              @if (selected()) {
                <div class="bg-inverted-neutral opacity-20 w-[1px] h-full" @fadeInOut></div>
              }
              <div class="flex items-center justify-center">
                <div class="inter-500 text-[12px] text-support-text mr-[10px]">Value</div>
                <input [(ngModel)]="answerOption.score"
                  class="bg-textbox-fill border border-textbox-border rounded-[8px] px-2 py-1 w-[100px] inter-300 text-[14px] outline-none"
                  required
                  type="number" />
                <div class="bg-inverted-neutral opacity-20 w-[1px] h-[30px] mx-[10px]"></div>
              </div>
            }
            @if (selected()) {
              <div class="bg-inverted-neutral opacity-20 w-[1px] h-full" @fadeInOut></div>
              <!-- Score input -->
              <label class="label cursor-pointer gap-2" @fadeInOut>
                <div class="inter-500 text-[12px] text-support-text">Score</div>
                <input [(ngModel)]="answerOption.score" class="bg-textbox-fill border border-textbox-border rounded-[8px] px-2 py-1 w-16 inter-300 text-[14px] outline-none" type="number">
              </label>
              <!-- Alert severity -->
              <div class="flex items-center gap-2">
                <div class="inter-500 text-[12px] text-support-text">Alert Level</div>
                <select class="bg-textbox-fill border border-textbox-border rounded-full px-3 py-1 inter-300 text-[14px] text-support-text appearance-none focus:outline-none" [(ngModel)]="answerOption.alertSeverityLevel">
                  @for (severityLevel of AlertSeverityLevel | keyvalue:unsorted; track severityLevel) {
                    <option [value]="severityLevel.value">{{ severityLevel.key }}</option>
                  }
                </select>
              </div>
              <!-- Free text input checkbox -->
              @if (question.type === QuestionType.SingleChoice) {
                <label class="label cursor-pointer gap-2" @fadeInOut
                  matTooltip="This option will allow the user to input a custom answer">
                  <div class="inter-500 text-[12px] text-support-text">Text Input</div>
                  <input [(ngModel)]="answerOption.includeFreeTextInput" class="toggle toggle-sm" type="checkbox" />
                </label>
              }
              <div (click)="deleteAnswerOption($event, answerOption)" matTooltip="Remove Option" @fadeInOut
                class="w-[32px] h-[32px] rounded-full hover:bg-textbox-fill cursor-pointer flex items-center justify-center transition-colors">
                <span class="material-symbols-outlined text-[20px]">close</span>
              </div>
            }
          </div>
        }

        @if (selected()) {
          <!-- 'Add Option' Placeholder -->
          <div @scaleHeightAndFade (click)="addAnswerOption()"
            class="bg-transparent border border-kek-purple text-kek-purple hover:bg-kek-purple hover:text-white px-4 py-1.5 rounded-full inter-500 text-[13px] transition-colors flex items-center gap-1 w-max mx-auto cursor-pointer">
            <span class="material-icons text-[16px]">add</span>
            {{ question.type === QuestionType.RangeSelection ? 'Add slider step...' : 'Add option...' }}
          </div>
        }
      </div>
    }

    <!-- Conditionality Section -->
    @if (shouldShowConditionalitySection() && selected()) {
      <div
        class="flex flex-col gap-4"
        @scaleHeightAndFade
        >
        <div class="flex items-center justify-end">
          <button (click)="addBranchCondition()"
            class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-4 py-2 rounded-full inter-500 text-[13px] transition-colors">
            Add Branch Condition
          </button>
        </div>
        @for (branchCondition of question.branchConditions; track branchCondition) {
          <div
            class="rounded-[16px] p-4 border border-textbox-border bg-surface-background mt-4"
            >
            <app-edit-branch-condition
              (branchConditionDeleted)="deleteBranchCondition($event)"
              [availableBranchQuestions]="availableBranchQuestions"
              [branchCondition]="branchCondition"
              [question]="question"
              />
            </div>
          }
        </div>
      }

      <!-- Toolbar Section -->
      @if (selected()) {
        <div class="h-[1px] bg-inverted-neutral opacity-20 w-full"></div>
        <div class="flex items-center justify-end gap-[20px] mr-[25px]" @scaleHeightAndFade>
          <div (click)="questionDuplicatedEvent.emit(question)" matTooltip="Duplicate Question"
            class="w-[36px] h-[36px] rounded-full border border-textbox-border hover:bg-textbox-fill cursor-pointer flex items-center justify-center transition-colors">
            <span class="material-symbols-outlined text-[20px]">content_copy</span>
          </div>
          <div (click)="questionDeletedEvent.emit(question)" matTooltip="Delete Question"
            class="w-[36px] h-[36px] rounded-full border border-textbox-border hover:bg-textbox-fill cursor-pointer flex items-center justify-center transition-colors">
            <span class="material-symbols-outlined text-[20px]">delete</span>
          </div>
          <div class="bg-inverted-neutral opacity-20 w-[1px] h-[40px]"></div>
          <label class="label cursor-pointer gap-2"
            matTooltip="This option will allow the user to input a custom answer">
            <div class="inter-500 text-[12px] text-support-text">Required</div>
            <input (ngModelChange)="question.isOptional = !$event" [ngModel]="!question.isOptional" class="toggle toggle-sm"
              type="checkbox" />
          </label>
        </div>
      }
    </div>
  </div>
